import styled from 'styled-components';
import { Paragraf } from '../Styled';

export const FaqKort = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 25px;
  max-width: 1200px;
  padding: 50px 0;
  border-radius: 20px;
`;


export const FaqPara = styled(Paragraf)`
  transform: translateY(-100%);
  margin: 0;
  padding: 0 25px;
  max-height: 0;
  opacity: 0;
  position: relative;
  z-index: 1;
  border-radius: 0 0 15px 15px;
  transition: all 500ms ease-out;
`;

export const FaqElement = styled.div`
background-color: ${({ theme }) => theme.mainColors.hvid};
  padding: 0;
  border-radius: 15px;
  box-shadow: 0 20px 30px 0 rgb(0 0 29 / 7%);
  & div h1 {
    position: relative;
    background-color: #fefefe;
    z-index: 2;
    padding: 25px;
    border-radius: 20px;
    margin: 0;
    transition: 500ms all ease-out;
    @media screen and (max-width: 768px) {
      font-size: 1.5rem;
    }
  }
  &:last-child {
    border: none;
  }
  &.active {
    & div h1 {
      background-color: ${({ theme }) => theme.mainColors.lightgreen};
      color: ${({ theme }) => theme.mainColors.hvid};
      border-radius: 15px 15px 0 0;
    }
    & ${FaqPara} {
      transform: translateY(0);
      padding: 25px;
      box-shadow: 0 25px 32px -23px rgba(0,0,0,0.25) inset;
  max-height: 400px;
  opacity: 1;
    }
  }
`;

